import { Routes, Route } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HomePage from '../pages/HomePage';
import ToolsPage from '../pages/ToolsPage';
import ToolPage from '../pages/ToolPage';

export default function AppRoutes() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tools" element={<ToolsPage />} />
          {/* Dynamic route — React Router v6 ranks static paths higher so /tools is safe */}
          <Route path="/:slug" element={<ToolPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
